import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { NewBookingPaymentPageForApp } from '../../../features/parking/ui/booking-pages/new-booking/NewBookingPaymentPageForApp';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default NewBookingPaymentPageForApp;
